import React, { useRef, useEffect, useState } from 'react';

import { FaVolumeMute } from 'react-icons/fa';
import { AiFillDatabase } from 'react-icons/ai';

import { useConnection } from '~/hooks/connection';

import { Container, Content } from './styles';

import { ConnectionProps } from './interface';

import api from '~/services/api';

const errorAudio = require('../../../assets/error.mp3');

const Connection: React.FC<ConnectionProps> = () => {
  const audioPlayer = useRef<HTMLAudioElement>(null);

  const { status, setStatus } = useConnection();
  const [audioStatus, setAudioStatus] = useState(true);

  const fetchConnectionStatus = async () => {
    try {
      const response = await api.get(`status-da-conexao`);

      const { data } = response;
      if (!data.error) {
        setStatus(data);
      }
    } catch (err) {}
  };

  useEffect(() => {
    const _interval = setInterval(() => {
      fetchConnectionStatus();
    }, 2 * 60 * 1000);

    return () => {
      clearInterval(_interval);
    };
  });

  useEffect(() => {
    fetchConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const muteSound = () => {
    if (audioPlayer && audioPlayer.current) {
      if (audioStatus) {
        audioPlayer.current.pause();
      } else {
        audioPlayer.current.play();
      }
    }
    setAudioStatus(!audioStatus);
  };

  if (status) {
    return null;
  }

  return (
    <Container>
      <audio ref={audioPlayer} src={errorAudio} autoPlay loop />
      <Content>
        <main>
          <i>
            <AiFillDatabase size={180} color="#fff" />
          </i>

          <div>
            <h1>FALHA NO ORACLE (TOTVS)</h1>
            <h2>Não conseguimos conectar ao banco de dados!</h2>
            <small>Por favor, acione o suporte o mais rápido possível!</small>

            <button onClick={muteSound}>
              {audioStatus ? (
                <FaVolumeMute size={32} color="#fff" />
              ) : (
                <FaVolumeMute size={32} color="rgba(255,255,255,0.2)" />
              )}
            </button>
          </div>
        </main>
      </Content>
    </Container>
  );
};

export default Connection;
